module.exports = __webpack_public_path__ + "img/violet_053.1340c3c9.png";